import React from "react";
import { bool, node, string, oneOf } from "prop-types";
import classNames from "classnames";
import "./Box.scss";

const Box = ({ id, display, component, className, column, grow, wrap, alignX, alignY, children }) => {
    const Component = component;

    return (
        <Component
            id={id}
            className={classNames(className, {
                "d-flex": display === "flex",
                "d-flex-inline": display === "inline-flex",
                "d-grid": display === "grid",
                "d-block": display === "block",
                "d-block-inline": display === "inline-block",
                "justify-content-start": alignX === "left",
                "justify-content-center": alignX === "center",
                "justify-content-end": alignX === "right",
                "justify-content-between": alignX === "between",
                "justify-content-around": alignX === "around",
                "justify-content-evenly": alignX === "evenly",
                "justify-content-stretch": alignX === "stretch",
                "align-items-start": alignY === "top",
                "align-items-center": alignY === "center",
                "align-items-end": alignY === "bottom",
                "align-items-stretch": alignY === "stretch",
                "align-items-baseline": alignY === "baseline",
                "flex-column": column,
                "flex-wrap": wrap,
                "flex-grow": grow,
            })}>
            <>{children}</>
        </Component>
    );
};

Box.propTypes = {
    children: node.isRequired,
    component: oneOf(["article", "aside", "div", "footer", "header", "main", "nav", "section", "span", "ul", "ol"]),
    id: string,
    display: oneOf(["flex", "inline-flex", "grid", "block", "inline-block"]),
    column: bool,
    grow: bool,
    wrap: bool,
    alignX: string,
    alignY: string,
    className: string,
};

Box.defaultProps = {
    component: "div",
    id: null,
    display: null,
    column: false,
    grow: false,
    wrap: false,
    alignX: "",
    alignY: "",
    className: "",
};

export default Box;
